import { Box, Button } from '@factorialco/deprecated-design-system'
import { BankingValueObjectsTransferSourceTypeEnum } from 'generated/resources/datatable.graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

interface PaymentExecutionActionsProps {
  revocable: boolean
  sourceType?: BankingValueObjectsTransferSourceTypeEnum | null
  sourceId?: number | null
  onRevoke?: () => void
}

const getSourceNavigationPath = (
  sourceType: BankingValueObjectsTransferSourceTypeEnum | null | undefined,
  sourceId: number | null | undefined,
  navigation: ReturnType<typeof useNavigation>['navigation']
): string | null => {
  if (!sourceType || !sourceId) {
    return null
  }

  switch (sourceType) {
    case 'expensable':
      return navigation.expenses.list.expenses.expenseId.fullPath({
        expense_id: sourceId,
      })
    case 'invoice':
      return navigation.finance.invoices.list.invoiceId.fullPath({
        invoiceId: sourceId,
      })
    case 'salary_advance_request':
      // TODO: Add navigation path when salary advance detail page is available
      return null
    case 'payroll':
    default:
      return null
  }
}

export const Actions = ({
  revocable,
  onRevoke,
  sourceType,
  sourceId,
}: PaymentExecutionActionsProps) => {
  const { navigation } = useNavigation()
  const sourcePath = getSourceNavigationPath(sourceType, sourceId, navigation)

  if (!revocable && !sourcePath) {
    return null
  }

  return (
    <Box gap="s4" flexDirection="row" justifyContent="flexEnd">
      <PopoverMenu type="list">
        {!!revocable && (
          <PopoverMenu.Trigger>
            <Button.Decorative type="secondary" iconName="ellipsis" />
          </PopoverMenu.Trigger>
        )}
        {!!sourcePath && (
          <PopoverMenu.Trigger>
            <Button.Router type="secondary" iconName="arrow-right" to={sourcePath} />
          </PopoverMenu.Trigger>
        )}
        {revocable && (
          <PopoverMenu.Content side="bottom" align="start">
            <PopoverMenu.TouchableOption
              title={i18n.t('banking.transfers.actions.remove_transfer')}
              onClick={onRevoke}
            />
          </PopoverMenu.Content>
        )}
      </PopoverMenu>
    </Box>
  )
}
